setTimeout(function () {
  $(".banner_slider").flickity({
    // options
    cellAlign: "left",
    prevNextButtons: false,
    contain: true,
    wrapAround: true,
    pageDots: true,
  });
}, 50000000);

setTimeout(function () {
  $(".slider_popular .new-grid").flickity({
    // options
    cellAlign: "left",
    prevNextButtons: true,
    contain: true,
    wrapAround: true,
    pageDots: false,
  });
}, 100);

setTimeout(function () {
  $(".RecentlyViewed_products_bommx .new-grid").flickity({
    // options
    cellAlign: "left",
    prevNextButtons: true,
    contain: true,
    wrapAround: true,
    pageDots: false,
  });
}, 1000);

setTimeout(function () {
  var slider = document.querySelector(".department_slider");
  $(".department_slider").flickity({
    // options
    cellAlign: "left",
    prevNextButtons: true,
    contain: true,
    wrapAround: true,
    pageDots: false,
  });
}, 1000);
setTimeout(function () {
  $(".popular_slider").flickity({
    // options
    cellAlign: "left",
    prevNextButtons: true,
    contain: true,
    wrapAround: true,
    pageDots: false,
  });
}, 1000);

setTimeout(function () {
  $(".testimonial_slider").flickity({
    cellAlign: "left",
    prevNextButtons: true,
    contain: true,
    wrapAround: true,
    pageDots: false,
  });
}, 1000);

mobileOnlySlider(".image_item_cnt", true, false, 767);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    arrows: true,
    prevArrow:
      '<button class="slick-button slick-prev slick-prev-next-button previous" type="button" aria-label="Previous"><svg class="slick-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
    nextArrow:
      '<button class="slick-button slick-next slick-prev-next-button next" type="button" aria-label="Next"><svg class="slick-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick",
      },
    ],
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}

$(document).ready(function () {
  $(".more a").click(function () {
    $(".menu_sidebar").addClass("active");
  });

  $(".close_cnt").click(function () {
    $(".menu_sidebar").removeClass("active");
  });

  $(".srotorder_popup_main_cnt label.form-label").click(function () {
    $(".srotorder_popup").addClass("active");
  });

  $(".sortclose_cnt").click(function () {
    $(".srotorder_popup").removeClass("active");
  });

  $(".pop_shop_by_price_main_cnt label.form-label").click(function () {
    $(".shop_by_price_popup").addClass("active");
  });

  $(".price_close_cnt").click(function () {
    $(".shop_by_price_popup").removeClass("active");
  });

  $("li.navUser-item.navUser-item--mobile-search").click(function () {
    $(".search_box").addClass("active");
  });
  $(".search_close").click(function () {
    $(".search_box").removeClass("active");
  });

  $("li.shop_button").click(function () {
    $(".category_side").addClass("active");
  });
  $(".category_side .close_cnt").click(function () {
    $(".category_side").removeClass("active");
  });

  $("li.account_button").click(function () {
    $(".account_side").addClass("active");
  });
  $(".account_side .close_cnt").click(function () {
    $(".account_side").removeClass("active");
  });

  $("li.hotline_button").click(function () {
    $(".bottomBar-contactPanel").toggleClass("active");
  });
  $(".bottomBar-contactPanel .close_cnt").click(function () {
    $(".bottomBar-contactPanel").removeClass("active");
  });
});
